
import vue from "vue";
import vuex from "vuex";
vue.use(vuex);

import baseModule from "../../../store/baseInfo";
import hotel from "./hotel";
import hotelService from "./hotel-service";
import profile from '../../profile/store/profile'
import unauthorizedHotel from './unauthorizedHotel'

export default new vuex.Store({
  modules: {
    baseModule,
    hotel, hotelService,
    profile,
    unauthorizedHotel
  }
});